<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-button (click)="onDismissIntegrationOutputModal()"
        ><ion-icon name="close"></ion-icon
      ></ion-button>
    </ion-buttons>
    <ion-title>{{ integration?.name }}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <ion-item *ngFor="let outputField of integrationOutput; let i = index">
    <ion-label position="stacked" style="display: flex; align-items: center"
      ><span>{{ outputField.label }}</span
      ><a
        ngxTippy
        data-tippy-content="Copy to clipboard"
        class="clipboard-icon"
        (click)="copyIntegrationOutputFieldToClipboard(i)"
      >
        <ion-icon name="copy-outline"></ion-icon> </a
    ></ion-label>
    <p style="line-break: anywhere">
      <span *ngIf="outputField.type !== 'link'">{{ outputField.value }}</span>
      <a
        *ngIf="outputField.type === 'link'"
        target="_blank"
        href="{{ outputField.value }}"
        >{{ outputField.value }}</a
      >
    </p>
  </ion-item>

  <ion-item *ngIf="integration.name === 'Zendesk'">
    <ion-label position="stacked" style="display: flex; align-items: center">
      <a
        href="https://docs.unthread.io/integrations/zendesk#2-zendesk-ui%3A"
        target="_blank"
      >
        Important: view instructions on next steps
        <ion-icon name="open-outline"></ion-icon>
      </a>
    </ion-label>
  </ion-item>
</ion-content>
